import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lang: 'uk'
};

const langSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.lang = action.payload;
    }
  }
});

export const { setLanguage } = langSlice.actions;
export default langSlice.reducer;
